export default __webpack_public_path__ + "static/kurorty-bg-ab8bada7aa35d0df3bcbcceb90dbf8a1.png";